export default "__VITE_ASSET__C8JES0Em__"